import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import Button from '@mui/material/Button'
import AssessmentIcon from '@mui/icons-material/Assessment'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import PersonIcon from '@mui/icons-material/Person'
import useReportPageUrlState from 'hooks/useReportPageUrlState'
import NavbarSearch from './NavbarSearch'
import {
  CurrentTenantContext,
  useCurrentUserContext,
} from '../contexts/CurrentUserContext'
import { Menu, MenuItem } from '@mui/material'
import { grey } from '@mui/material/colors'

export const NAVBAR_HEIGHT = 80

const Navbar: React.FC = () => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  const { reportId, sectionId } = useReportPageUrlState()
  const currentUser = useCurrentUserContext()

  const exitBetaViewUrl = currentUser?.admin
    ? `/admin/reports/${reportId}`
    : sectionId
      ? `/report_sections/${sectionId}/`
      : '/'

  const tenant = useContext(CurrentTenantContext)
  const isYouthtruth = tenant?.body_class === 'youthtruth_subdomain'

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        elevation={0}
        sx={{ backgroundColor: isYouthtruth ? 'white' : 'primary' }}
      >
        <Toolbar
          sx={{
            height: NAVBAR_HEIGHT,
            py: 2,
            backgroundColor: isYouthtruth ? 'white' : 'primary',
            borderBottom: isYouthtruth ? `1px solid ${grey[300]}` : '',
          }}
        >
          {currentUser ? (
            <Link to="/">
              <Box
                component="img"
                src={isYouthtruth ? '/YT_Logo.png' : '/cep-logo-white.svg'}
                sx={{
                  height: isYouthtruth ? NAVBAR_HEIGHT - 30 : '100%',
                  position: 'relative',
                  top: isYouthtruth ? 10 : 0,
                }}
              />
            </Link>
          ) : (
            <Box
              component="img"
              src={isYouthtruth ? '/YT_Logo.png' : '/cep-logo-white.svg'}
              sx={{
                height: isYouthtruth ? NAVBAR_HEIGHT - 30 : '100%',
                position: 'relative',
                top: isYouthtruth ? 10 : 0,
              }}
            />
          )}
          <NavbarSearch />
          <Box sx={{ flexGrow: 1 }} />
          <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
            {currentUser && !currentUser?.admin && (
              <Button
                component={Link}
                to="/"
                sx={{
                  color: isYouthtruth ? 'primary' : '#fff',
                  mr: 2,
                  fontWeight: 'bold',
                }}
                startIcon={<AssessmentIcon sx={{ color: 'secondary.light' }} />}
              >
                My Reports
              </Button>
            )}
            {/* What should this do? */}
            {/* {!currentUser?.admin && (
              <Button
                sx={{ color: isYouthtruth ? 'primary' : '#fff', mr: 2 }}
                startIcon={<HelpOutlineIcon />}
              >
                Help
              </Button>
            )} */}
            {currentUser && !currentUser?.admin && (
              <>
                <Button
                  sx={{ color: isYouthtruth ? 'primary' : '#fff', mr: 2 }}
                  startIcon={<PersonIcon />}
                  id="account-menu-button"
                  aria-controls={open ? 'account-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? 'true' : undefined}
                  onClick={handleClick}
                >
                  Account
                </Button>
                <Menu
                  id="account-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    'aria-labelledby': 'account-menu-button',
                  }}
                >
                  <MenuItem component="a" href="/client/edit">
                    Change Password
                  </MenuItem>
                  <MenuItem
                    component="a"
                    href="/clients/account_two_factor/edit"
                  >
                    Manage Two-Factor Authentication
                  </MenuItem>
                  <MenuItem component="a" href="/clients/sign_out">
                    Sign Out
                  </MenuItem>
                </Menu>
              </>
            )}
          </Box>
        </Toolbar>
      </AppBar>
      <Box sx={{ height: NAVBAR_HEIGHT }} />
    </Box>
  )
}

export default Navbar
